module.exports = __webpack_public_path__ + "static/media/StJohnPaulCatholicAcademyLowerMills.74f898da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/main/StJohnPaulCatholicAcademyLowerMills.jpg
// module id = 772
// module chunks = 0